export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/mashable-9577ebc8c7c5c8e56aef6a6410a58625.png";